<template>
  <layout-image-orange :meals="meals" />
</template>

<script>
import LayoutImageOrange from "./layout-image-orange"

export default {
  maxMeals: LayoutImageOrange.maxMeals,
  slicer: LayoutImageOrange.slicer,
  name: "layout-image-orange-with-number",
  props: ["meals"],
  components: { LayoutImageOrange }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/style.scss";

::v-deep .meal-jumbo {
  .meal-number {
    display: unset;
    position: absolute;
    left: 0.1em;
    top: 0.75em;
    background-color: rgba(238, 238, 238, 0.88);
    height: 1.5em;
    width: 1.5em;
    border-radius: 52%;
    border: #222 solid 1px;
    font-size: 7em;
    text-align: center;
  }
}
</style>
